import { useMemo } from 'react';
import { MediaType } from '@/helpers/enums';
import { useResponsive } from '@/modules/client';
import {
  defaultGridOptions,
  defaultPerChunk,
  type GridDimensions,
} from './helpers';

export const useGridDimensions = ({
  perChunkObj = defaultPerChunk,
  gridOptions = defaultGridOptions,
}: GridDimensions) => {
  const { currentMediaType } = useResponsive();

  const { perChunk, gridColumns } = useMemo(() => {
    switch (currentMediaType) {
      case MediaType.DESKTOP_L:
        return {
          perChunk: perChunkObj.desktopL,
          gridColumns: gridOptions.columns,
        };
      case MediaType.DESKTOP:
        return {
          perChunk: perChunkObj.desktop,
          gridColumns: gridOptions.columns,
        };
      case MediaType.TABLET:
        return {
          perChunk: perChunkObj.tablet,
          gridColumns: gridOptions.columnsTablet,
        };
      case MediaType.MOBILE:
        return {
          perChunk: perChunkObj.mobile,
          gridColumns: gridOptions.columnsMobile,
        };
      case MediaType.MOBILE_S:
      default:
        return {
          perChunk: perChunkObj.mobileS,
          gridColumns: gridOptions.columnsMobileS,
        };
    }
  }, [currentMediaType, perChunkObj, gridOptions]);

  return { perChunk, gridColumns };
};
